import { createApp } from 'vue'
import App from './src/App.vue'
import './src/assets/sherd-theme.css'

const app = createApp(App)
app.mount('#app') 